const _cities = [
    {
        id: 1,
        name: 'Gent',
        link: 'https://gent.fosopenscouting.be/'
    },
    {
      id: 2,
      name: 'Antwerpen',
      link: 'https://antwerpen.fosopenscouting.be/'
    },
  ];
  
  export default {
    getCities (cb) {
      setTimeout(() => cb(_cities), 1)
    }
  }
  


// WEBPACK FOOTER //
// ./src/api/cities.js